export default __webpack_public_path__ + "static/media/High-flexibility-icon.fd8e174d.png";